// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
// import UserLogin from '../components/UserLogin.vue';
// import UserRegister from '../components/UserRegister.vue';

Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/register',
    //     name: 'register',
    //     component: UserRegister
    // },
    // {
    //     path: '/',
    //     name: 'login',
    //     component: UserLogin
    // }
];

const router = new VueRouter({
    mode: 'history', // 可选项: 'hash' | 'history' | 'abstract'
    base: process.env.BASE_URL,
    routes
});

export default router;
